import {cn} from '@heroui/react'
import React from 'react'

import Box from '@/components/UI/Box/Box'

const AmyContainer = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return (
    <Box className={cn('max-w-7xl mx-auto w-full px-2 lg:px-0', className)}>
      {children}
    </Box>
  )
}

export default AmyContainer
